import React, { useContext, useMemo } from 'react';

import { ApiContext } from '_lib/api/apiContext';
import { ServiceTitanJobType } from '_lib/api/apiTypes.shim';

import { ManualErrorBoundary } from '_lib/components/ManualErrorBoundary/ManualErrorBoundary';
import { MenuItem } from '_lib/components/MenuItem/MenuItem';
import { TextField } from '_lib/components/TextField/TextField';
import { Typography } from '_lib/components/Typography/Typography';
import { FieldIssueProps } from '_lib/utils/validationErrorUtils';

export interface JobTypeSelectProps extends FieldIssueProps {
  companyId: string;
  onSetJobType: (jobType: ServiceTitanJobType) => void;
  jobType?: ServiceTitanJobType;
  disabled?: boolean;
}

export const JobTypeSelect = (props: JobTypeSelectProps) => {
  const { companyId, onSetJobType, jobType, disabled, issuePath, issues } = props;

  const api = useContext(ApiContext);
  const serviceTitanApi = useMemo(() => api.serviceTitan(companyId), [api, companyId]);
  const jobTypesQuery = serviceTitanApi.jobTypes.useUnpagedListCached();

  if (jobTypesQuery.error) {
    return (
      <ManualErrorBoundary
        errorState={{ message: 'Failed to load Job Types' }}
        onRefresh={async () => {
          await jobTypesQuery.refetch();
        }}
      />
    );
  }

  return (
    <TextField
      fullWidth
      label='Job Type'
      required
      disabled={disabled}
      value={jobType?.providerId || ''}
      defaultValue={''}
      select
      error={{
        issues,
        issuePath
      }}
      onChange={(e) => {
        const selectedJobType = jobTypesQuery.data?.find((c) => c.providerId === e.target.value);
        if (selectedJobType) onSetJobType(selectedJobType);
      }}>
      {jobTypesQuery.data &&
        jobTypesQuery.data?.length > 0 &&
        jobTypesQuery.data.map((jobType) => (
          <MenuItem key={jobType.providerId} value={jobType.providerId}>
            <Typography text={jobType.name} />
          </MenuItem>
        ))}
      {(!jobTypesQuery.data || jobTypesQuery.data?.length === 0) && <MenuItem disabled>No Job Types found.</MenuItem>}
    </TextField>
  );
};
